import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BoxedSliderField } from "web_myplann/Inspiration/Components/BoxedSliderField";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import { EarlyFreedomScenarioList } from "web_myplann/Inspiration/EarlyFreedom/Components/EarlyFreedomScenarioList";
import {
	EARLY_FREEDOM_SAVING_MAX,
	EARLY_FREEDOM_SAVING_MIN,
	EARLY_FREEDOM_SAVING_STEP,
} from "web_myplann/Inspiration/EarlyFreedom/constants";
import type {
	EarlyFreedomContext,
	EarlyFreedomScenarioKey,
} from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";

const R = Resources.Inspiration.EarlyFreedom;

type Props = {
	context: EarlyFreedomContext;
	onChange: (value: number) => void;
	onSelectScenario: (scenario: EarlyFreedomScenarioKey) => void;
};

export const EarlyFreedomPaceSection: FC<Props> = ({
	context,
	onChange,
	onSelectScenario,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<InspirationSection title={t(R.paceTitle)} gap={theme.spacingTokens.md}>
			<BoxedSliderField
				label={t(R.paceSliderLabel)}
				value={context.monthlySaving}
				onChange={onChange}
				min={EARLY_FREEDOM_SAVING_MIN}
				max={EARLY_FREEDOM_SAVING_MAX}
				step={EARLY_FREEDOM_SAVING_STEP}
			/>

			<EarlyFreedomScenarioList
				scenarios={context.scenarios}
				selected={context.selectedScenario}
				onSelect={onSelectScenario}
			/>

			<Typography variant="hint" color={theme.palette.grey[500]}>
				{t(R.paceNote)}
			</Typography>
		</InspirationSection>
	);
};
